import { adminClient, organizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

function resolveBaseURL(): string {
  if (typeof window === "undefined") return "http://localhost:3000";
  const origin = window.location?.origin;
  if (typeof origin === "string" && /^https?:\/\//.test(origin)) return origin;
  return "http://localhost:3000";
}

export const authClient = createAuthClient({
  baseURL: resolveBaseURL(),
  plugins: [adminClient(), organizationClient()],
});

export const { signIn, signUp, signOut, useSession } = authClient;
